import PropTypes from 'prop-types';

var propTypes = {
    numberOfPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    pagesDisplayedLimit: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    singlePage: PropTypes.bool,
    className: PropTypes.string,
    firstPageButtonText: PropTypes.string,
    lastPagePrefixButtonText: PropTypes.string,
    'data-testid': PropTypes.string,
    v2: PropTypes.bool,
};
var defaultProps = {
    firstPageButtonText: 'First',
    lastPagePrefixButtonText: 'Page',
    pagesDisplayedLimit: 3,
    'data-testid': 'pagination',
    className: '',
};

export { defaultProps, propTypes };
